import React from 'react';
import { TablePagination, TableContainer, Table, TableBody, Paper, TableRow } from '@mui/material';
import SharedContactsTableHeader from './SharedContactsTableHeader';
import { visibleSharedJournalistCols } from './Utils/constants';
import { getStrippedRow } from './Utils/functions';
import SharedJournalistsTableCell from './SharedJournalistsTableCell';
import { SharedJournalistsTableProps } from './Types/componentProps';

const SharedJournalistsTable = (props: SharedJournalistsTableProps) => {
  const { contactsData, page, pageSize, onPageChange, onPageSizeChange } = props;

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          overflow: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: '#C5CCD8 transparent',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C5CCD8',
            borderRadius: '999px',
            border: '2px solid transparent',
            backgroundClip: 'content-box',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#AFB8C7',
          },
        }}
      >
        <Table stickyHeader>
          <SharedContactsTableHeader columns={visibleSharedJournalistCols} />
          <TableBody>
            {contactsData.contacts.map((contact, index) => (
              <TableRow key={contact.id} sx={{ backgroundColor: getStrippedRow(index) }}>
                {visibleSharedJournalistCols.map((col) => (
                  <SharedJournalistsTableCell key={col} col={col} contact={contact} />
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={contactsData.totalCount}
        onPageChange={(_event, page) => onPageChange(page)}
        page={page}
        rowsPerPage={pageSize}
        rowsPerPageOptions={[25, 50, 100, 150]}
        onRowsPerPageChange={(event) => onPageSizeChange(parseInt(event.target.value, 10))}
      />
    </>
  );
};

export default SharedJournalistsTable;
